import React, { useEffect, useRef, useState } from "react";
import { Card, Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "components/custom/Loader";
import Formioform from "components/forms/FormioForm";
import LanguageGate from "components/common/LanguageGate";

const WHV_CACHE_KEY = "whv:lastState";

function WorkflowHistoryView() {
	const location = useLocation();
	const navigate = useNavigate();
	const state = location.state;

	const [form, setForm] = useState(null);
	const didSelfRestoreRef = useRef(false);

	useEffect(() => {
		try {
			if (state?.data) {
				setForm(state.data);
				sessionStorage.setItem(WHV_CACHE_KEY, JSON.stringify(state.data));
			} else {
				const cached = sessionStorage.getItem(WHV_CACHE_KEY);
				if (cached && !didSelfRestoreRef.current) {
					didSelfRestoreRef.current = true;
					const restored = JSON.parse(cached);

					navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: { data: restored } });
					return;
				}

				setForm(null);
			}
		} catch (e) {
			setForm(null);
			// console.error(e);
		}
	}, [location.key]);

	if (!form) {
		return (
			<Container>
				<Card className="p-4">
					<Loader />
				</Card>
			</Container>
		);
	}

	return (
		<Container>
			<Card title="Result" className="p-4">
				<LanguageGate>
					<Formioform form={form} />
				</LanguageGate>
			</Card>
		</Container>
	);
}

export default WorkflowHistoryView;
